import React, { useState, useEffect } from "react";
import { Col, Form, Row, Alert, InputGroup } from "react-bootstrap";
import CreateSearchableDropdown from "../CreateSearchableDropdown";
import CreateTextArea from "../CreateTextArea";
import CreateDateInput from "../CreateDateInput";
import CreateTextInput from "../CreateTextInput";
import CreateTableTextInput from "./CreateTableTextInput";
import CreateButtonsFromSelection from "../CreateButtonsFromSelection";
import uuid from "uuid/v1";

const CreateCalculosCusto = (props) => {
  const { blockdivision } = props;

  const [licCamarariaRep, setFormData1] = useState("");
  const [dtValidadeLicRep, setFormData2] = useState("");
  const [mccr_observacoes, setFormData3] = useState("");
  const [orcClienteRep, setFormData4] = useState("");
  const [orcAceiteRep, setFormData5] = useState("");
  const [numLicRep, setFormData6] = useState("");
  const [empreiteiroRep, setFormData7] = useState("");
  const [aplicarTodas, setFormData8] = useState("");
  const [fracaoRai, setFormData9] = useState("");
  const [seccao, setFormData10] = useState("");
  const [areaBruta, setFormData11] = useState("");
  const [mccr_percE, setFormData12] = useState("");
  const [mccr_percD, setFormData13] = useState("");
  const [mccr_percConstReal, setFormData14] = useState("");
  const [mccr_percL, setFormData15] = useState("");

  const [valorMetComp, setvalorMetComp] = useState("");
  const [tableCustoTerreno, setTable1] = useState("");
  const [tableConstrucao, setTable2] = useState("");

  useEffect(() => {
    if (blockdivision) {
      //find form data
      let licCamarariaRep;
      let dtValidadeLicRep;
      let mccr_observacoes;
      let orcClienteRep;
      let orcAceiteRep;
      let numLicRep;
      let empreiteiroRep;
      let aplicarTodas;
      let fracaoRai;
      let seccao;
      let tableCustoTerreno;
      let tableConstrucao;
      let areaRep;
      let mccr_percE;
      let mccr_percD;
      let mccr_percConstReal;
      let mccr_percL;

      let valorMetComp;

      const setValue = (f) => {
        if (f?.variable == "licCamarariaRep") {
          licCamarariaRep = f;
        }
        if (f?.variable == "dtValidadeLicRep") dtValidadeLicRep = f;
        if (f?.variable == "mccr_observacoes") mccr_observacoes = f;
        if (f?.variable == "orcClienteRep") orcClienteRep = f;
        if (f?.variable == "orcAceiteRep") orcAceiteRep = f;
        if (f?.variable == "numLicRep") numLicRep = f;
        if (f?.variable == "empreiteiroRep") empreiteiroRep = f;
        if (f?.variable == "aplicarTodas") aplicarTodas = f;
        if (f?.variable == "fracaoRai") fracaoRai = f;
        if (f?.variable == "seccao") seccao = f;
        if (f?.variable == "areaRep") areaRep = f;
        if (f?.variable == "mccr_percE") mccr_percE = f.value;
        if (f?.variable == "mccr_percD") mccr_percD = f.value;
        if (f?.variable == "mccr_percConstReal") mccr_percConstReal = f.value;
        if (f?.variable == "mccr_percL") mccr_percL = f.value;

        if (f?.text == "Valor Met Comp") valorMetComp = f.value;
        if (f?.type == "arraytable") {
          if (f?.row[0]?.col[0]?.value === "Custo do Terreno (T)") {
            tableCustoTerreno = f;
          }
          if (
            f?.row[0]?.col[0]?.value === "Custos Directos de construção (CC)"
          ) {
            tableConstrucao = f;
          }
        }
      };
      let blockdivision_ = JSON.parse(JSON.stringify(blockdivision));
      if (!Array.isArray(blockdivision_)) {
        blockdivision_ = [blockdivision_];
      }
      blockdivision.forEach((b) => {
        if (Array.isArray(b.columndivision)) {
          b.columndivision.forEach((c) => {
            if (Array.isArray(c.field)) {
              c.field.forEach((f) => {
                setValue(f);
              });
            } else {
              setValue(c.field);
            }
          });
        } else {
          if (Array.isArray(b.columndivision?.field)) {
            b.columndivision.field.forEach((f) => {
              setValue(f);
            });
          } else {
            setValue(b.columndivision.field);
          }
        }
      });

      setFormData1(licCamarariaRep);
      setFormData2(dtValidadeLicRep);
      setFormData3(mccr_observacoes);
      setFormData4(orcClienteRep);
      setFormData5(orcAceiteRep);
      setFormData6(numLicRep);
      setFormData7(empreiteiroRep);
      setFormData8(aplicarTodas);
      setFormData9(fracaoRai);
      setFormData10(seccao);
      setFormData11(areaRep);
      setFormData12(mccr_percE);
      setFormData13(mccr_percD);
      setFormData14(mccr_percConstReal);
      setFormData15(mccr_percL);

      setvalorMetComp(valorMetComp);
      setTable1(tableCustoTerreno);
      setTable2(tableConstrucao);
    }
  }, [blockdivision]);

  //const formatter = new Intl.NumberFormat("pt-PT", {
  const formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });

  //const decimalFormatter = new Intl.NumberFormat("pt-PT", {
  const decimalFormatter = new Intl.NumberFormat("de-DE", {
    style: "decimal",
  });

  const numberFormatter = new Intl.NumberFormat("de-DE");

  function parseCurrency(arg) {
    return arg.replace(/[^\d,]/g, "").replace(/,/g, ".");
  }

  function parseNumber(arg) {
    return Number(arg.replace(/[,]/g, ""));
  }

  function updateWarning() {
    let comparativo = "";
    if (
      document.getElementById("valorMetComp")?.textContent &&
      document.getElementById("valorMetCustos")?.textContent
    ) {
      let valorMetComp = Number(
        parseCurrency(document.getElementById("valorMetComp").textContent)
      );
      let valorComercial = Number(
        parseCurrency(document.getElementById("valorMetCustos").textContent)
      );

      if (valorMetComp > valorComercial) {
        if (document.getElementById("reverValor")) {
          document.getElementById("reverValor").style.display = "none";
        }
        comparativo = ">";
      } else {
        if (document.getElementById("reverValor")) {
          document.getElementById("reverValor").style.display = "block";
        }
        comparativo = "<";
      }
    }
    return comparativo;
  }

  /*First render*/
  useEffect(() => {
    const comparativo = updateWarning();
    document.getElementById("comparativo").textContent = comparativo;
    updateTotais(64, 72);
  }, [tableCustoTerreno, tableConstrucao]);

  function updateTotais(tabelaTerrenos, tabelaConstrucao) {
    let numLinhasTerreno = 2;
    let totTerreno = 0;
    while (
      document.getElementById(tabelaTerrenos + "_" + numLinhasTerreno + "_4") !=
      null
    ) {
      totTerreno += Number(
        parseCurrency(
          document.getElementById(
            tabelaTerrenos + "_" + numLinhasTerreno + "_4"
          ).textContent
        )
      );
      numLinhasTerreno++;
    }

    document.getElementById("totalTerreno").textContent = formatter.format(
      totTerreno.toFixed(2)
    );

    let numLinhasConstrucao = 2;
    let totConstrucao = 0;
    while (
      document.getElementById(
        tabelaConstrucao + "_" + numLinhasConstrucao + "_4"
      ) != null
    ) {
      totConstrucao += Number(
        parseCurrency(
          document.getElementById(
            tabelaConstrucao + "_" + numLinhasConstrucao + "_4"
          ).textContent
        )
      );
      numLinhasConstrucao++;
    }

    document.getElementById("custosConstrucao").textContent = formatter.format(
      totConstrucao.toFixed(2)
    );

    let perEncargos =
      Number(
        document.getElementById("encargos").getElementsByTagName("input")[0]
          .value
      ) / 100;
    let valorEncargos = perEncargos * totConstrucao;

    document.getElementById("valorEncargos").textContent = formatter.format(
      valorEncargos.toFixed(2)
    );

    let valorCCEncargos = (1 + perEncargos) * totConstrucao;

    document.getElementById("ccEncargos").textContent = formatter.format(
      valorCCEncargos.toFixed(2)
    );

    let custoTotal = valorCCEncargos + totTerreno;

    document.getElementById("custoTotal").textContent = formatter.format(
      custoTotal.toFixed(2)
    );

    let margemLucro =
      Number(
        document.getElementById("margemLucro").getElementsByTagName("input")[0]
          .value
      ) / 100;
    let lucro = margemLucro * custoTotal;

    document.getElementById("lucro").textContent = formatter.format(
      lucro.toFixed(2)
    );

    let valorNovo = custoTotal + lucro;

    document.getElementById("valorNovo").textContent = formatter.format(
      valorNovo.toFixed(2)
    );

    let perDepreciacao =
      Number(
        document
          .getElementById("perDepreciacao")
          .getElementsByTagName("input")[0].value
      ) / 100;
    let depreciacao = perDepreciacao * (valorCCEncargos + lucro);

    document.getElementById("depreciacao").textContent = formatter.format(
      depreciacao.toFixed(2)
    );

    let perConstrucao =
      Number(
        document
          .getElementById("perConstrucao")
          .getElementsByTagName("input")[0].value
      ) / 100;
    let valorAtual =
      totTerreno + perConstrucao * (valorCCEncargos + lucro) - depreciacao;

    document.getElementById("valorAtual").textContent = formatter.format(
      valorAtual.toFixed(2)
    );

    document.getElementById("valorSeguro").textContent = formatter.format(
      valorCCEncargos.toFixed(2)
    );

    let valorComercial = valorNovo - depreciacao;
    document.getElementById("valorComercial").textContent = formatter.format(
      valorComercial.toFixed(2)
    );

    document.getElementById("valorMetCustos").textContent = formatter.format(
      valorComercial.toFixed(2)
    );

    let comparativo = updateWarning();
    document.getElementById("comparativo").textContent = comparativo;

    let areaBruta;
    if (document.getElementById("areaBruta")) {
      areaBruta = parseNumber(document.getElementById("areaBruta").value);
    }

    let ivAdoptado = 0;
    if (areaBruta > 0) {
      ivAdoptado = valorComercial / areaBruta;
    } else {
      ivAdoptado = Number("0");
    }

    document.getElementById("ivAdoptado").innerHTML = decimalFormatter.format(
      ivAdoptado.toFixed(2)
    );
  }

  function updateTabelaTerrenos(linha, tabelaTerrenos, tabelaConstrucao) {
    let tableid = tabelaTerrenos;

    let colArea = "2";
    let colUnit = "3";
    let colTot = "4";

    /*
    let valorArea = parseNumber(
      document.getElementById(tableid + "_" + linha + "_" + colArea).textContent
    );*/

    let valorArea = Number(
      document
        .getElementById(tableid + "_" + linha + "_" + colArea)
        .textContent.replace(/[.]/g, "")
        .replace(/[,]/g, ".")
    );
    let valorUnit = parseNumber(
      document
        .getElementById(tableid + "_" + linha + "_" + colUnit)
        .getElementsByTagName("input")[0].value
    );

    let valorTot = valorArea * valorUnit;

    document.getElementById(tableid + "_" + linha + "_" + colTot).textContent =
      formatter.format(valorTot.toFixed(2));

    updateTotais(tabelaTerrenos, tabelaConstrucao);
  }

  function updateTabelaConstrucao(linha, tabelaTerrenos, tabelaConstrucao) {
    let tableid = tabelaConstrucao;

    //var colTerreno = "1";
    let colArea = "2";
    let colUnit = "3";
    let colTot = "4";

    /*
    let valorArea = parseNumber(
      document.getElementById(tableid + "_" + linha + "_" + colArea).textContent
    );*/

    let valorArea = Number(
      document
        .getElementById(tableid + "_" + linha + "_" + colArea)
        .textContent.replace(/[.]/g, "")
        .replace(/[,]/g, ".")
    );
    let valorUnit = parseNumber(
      document
        .getElementById(tableid + "_" + linha + "_" + colUnit)
        .getElementsByTagName("input")[0].value
    );

    let valorTot = valorArea * valorUnit;

    document.getElementById(tableid + "_" + linha + "_" + colTot).textContent =
      formatter.format(valorTot.toFixed(2));

    updateTotais(tabelaTerrenos, tabelaConstrucao);
  }

  const renderTable = (table, tableId, variable, onBlur) => {
    if (table && Array.isArray(table.row)) {
      return table.row.map((r, index) => {
        if (index != 0) {
          return (
            <tr key={index}>
              {Array.isArray(r.col) &&
                r.col.map((c, i) => {
                  let style =
                    i !== 0 ? { textAlign: "end" } : { textAlign: "start" };

                  if (i == 1) {
                    return (
                      <td
                        key={i}
                        id={`${tableId}_${index + 1}_${i + 1}`}
                        style={{ ...style, fontSize: fontSize }}
                      >
                        {
                          /*1,250.08 -> 1.250,08*/
                          numberFormatter.format(c.value.replace(/[,]/g, ""))
                        }
                      </td>
                    );
                  } else if (i == 2) {
                    return (
                      <CreateTableTextInput
                        key={i}
                        id={`${tableId}_${index + 1}_${i + 1}`}
                        name={`${variable}[${index - 1}]`}
                        value={c?.value?.input?.value}
                        linha={index + 1}
                        onBlur={onBlur}
                      />
                    );
                  } else
                    return (
                      <td
                        key={i}
                        id={`${tableId}_${index + 1}_${i + 1}`}
                        style={{ ...style, fontSize: fontSize }}
                      >
                        {c.value}
                      </td>
                    );
                })}
            </tr>
          );
        }
      });
    }
  };

  const fontSize = "1rem";
  const style1 = {
    flexWrap: "nowrap",
    marginLeft: "0px",
    marginRight: "0px",
    marginBottom: "0px",
    flexGrow: "1",
  };

  const style2 = {
    flexWrap: "nowrap",
    marginLeft: "0px",
    marginRight: "0px",
    marginBottom: "5px",
    flexGrow: "1",
    justifyContent: "flex-end",
  };

  const style3 = {
    flexWrap: "nowrap",
    marginLeft: "0px",
    marginRight: "0px",
    marginBottom: "5px",
    flexGrow: "1",
  };

  const style4 = {
    flexWrap: "nowrap",
    marginLeft: "0px",
    marginRight: "0px",
    flexGrow: "1",
  };

  const style5 = {
    flexWrap: "nowrap",
    marginLeft: "0px",
    marginRight: "0px",
    marginBottom: "5px",
    width: "30%",
  };

  const style6 = {
    flexWrap: "nowrap",
    marginLeft: "0px",
    marginRight: "0px",
    marginBottom: "5px",
    width: "20%",
  };

  const style7 = {
    flexWrap: "nowrap",
    marginLeft: "0px",
    marginRight: "0px",
    marginBottom: "5px",
    width: "50%",
  };

  const style8 = {
    flexWrap: "nowrap",
    marginLeft: "0px",
    marginRight: "0px",
    marginBottom: "5px",
    flexGrow: "1",
  };

  const style9 = {
    flexGrow: "1",
    fontWeight: "bold",
    textAlign: "end",
    fontSize: "1rem",
  };

  const style10 = {
    padding: "5px 0px 10px 0px",
    fontSize: "1rem",
  };

  const style11 = {
    flexGrow: "1",
    fontWeight: "bold",
    textAlign: "start",
  };

  const renderColumnContent = () => {
    return (
      <>
        {seccao && <CreateButtonsFromSelection field={seccao} />}
        {fracaoRai && (
          <CreateSearchableDropdown field={fracaoRai} key={"fracaoRai"} />
        )}
        {aplicarTodas && (
          <CreateSearchableDropdown field={aplicarTodas} key={"aplicarTodas"} />
        )}
        <Form.Group key={uuid()} style={style1}>
          <Form.Label column style={{ flexGrow: "1" }}>
            <h4>Método do custo de construção ou reposição</h4> <hr />
          </Form.Label>
        </Form.Group>
        <Alert variant="info">
          O método do custo de reposição / substituição é utilizado na
          determinação do valor de um imóvel através da soma entre o valor de
          mercado do terreno e de todos os custos necessários para a construção
          de um imóvel com as mesmas características físicas e funcionais. Deve
          ser tido em conta no valor final do imóvel, a sua depreciação em
          função da antiguidade, estado de conservação, estimativa de vida útil
          e margens de lucro requeridas.
        </Alert>

        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th
                id="64_1_1"
                style={{ ...style10, width: "25%", textAlign: "start" }}
              >
                Custo do Terreno (T)
              </th>
              <th
                id="64_1_2"
                style={{ ...style10, width: "20%", textAlign: "end" }}
              >
                Área (m2)
              </th>
              <th
                id="64_1_3"
                style={{ ...style10, width: "25%", textAlign: "end" }}
              >
                Valor (€/m2)
              </th>
              <th
                id="64_1_4"
                style={{ ...style10, width: "30%", textAlign: "end" }}
              >
                Valor Total
              </th>
            </tr>
          </thead>

          <tbody>
            {renderTable(
              tableCustoTerreno,
              64,
              "listaValorTerreno_rep",
              updateTabelaTerrenos
            )}
          </tbody>
        </table>
        <br />
        <Form.Group as={Row} style={style2}>
          <Col
            key={`columndivision_1}`}
            style={{ flexGrow: "0.30", padding: "0" }}
          >
            <Form.Group as={Row} style={style1}>
              <Form.Label column style={{ flexGrow: "1", fontSize: fontSize }}>
                T - Terreno =
              </Form.Label>
              <Form.Label id="totalTerreno" column style={style9}>
                {" "}
              </Form.Label>
            </Form.Group>
            <hr />
          </Col>
        </Form.Group>

        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th
                id="72_1_1"
                style={{ ...style10, textAlign: "start", width: "25%" }}
              >
                Custos Directos de construção (CC)
              </th>
              <th
                id="72_1_2"
                style={{ ...style10, width: "20%", textAlign: "end" }}
              >
                Área (m2)
              </th>
              <th
                id="72_1_3"
                style={{ ...style10, width: "25%", textAlign: "end" }}
              >
                Custo (€/m2)
              </th>
              <th
                id="72_1_4"
                style={{ ...style10, width: "30%", textAlign: "end" }}
              >
                Valor Total
              </th>
            </tr>
          </thead>

          <tbody>
            {renderTable(
              tableConstrucao,
              72,
              "listaCusto",
              updateTabelaConstrucao
            )}
          </tbody>
        </table>
        <br />
        <Form.Group as={Row} style={style2}>
          <Col
            key={`columndivision_1}`}
            style={{ flexGrow: "0.3", padding: "0" }}
          >
            <Form.Group as={Row} style={style3}>
              <Form.Label column style={{ flexGrow: "1" }}>
                Custos Directos de construção (CC)
              </Form.Label>
              <Form.Label id="custosConstrucao" column style={style9}>
                {" "}
              </Form.Label>
            </Form.Group>
            <hr />
          </Col>
        </Form.Group>
        <br />

        <Form.Group as={Row} style={style4}>
          <Form.Group id="encargos" as={Row} style={style5}>
            <Form.Label
              id="label_mccr_percE"
              column
              style={{ flexGrow: "1", fontSize: fontSize }}
            >
              Encargos Indiretos (% de CC)
            </Form.Label>
            <input
              id="mccr_percE"
              style={{ width: "30%" }}
              className="form-control create-text-input-suffix-fix"
              type="text"
              size={6}
              name={"mccr_percE"}
              maxLength={6}
              value={mccr_percE}
              onChange={(e) => setFormData12(e.target.value)}
              onBlur={() => {
                updateTotais(64, 72);
              }}
            />
            <InputGroup.Append>
              <InputGroup.Text
                className={"create-text-input-suffix"}
                style={{ height: "44px" }}
              >
                %
              </InputGroup.Text>
            </InputGroup.Append>
          </Form.Group>
          <Form.Group as={Row} style={style6}>
            <Form.Label
              id="label_mccr_valorE"
              column
              style={{ flexGrow: "1", fontSize: fontSize }}
            >
              E =
            </Form.Label>
            <Form.Label
              id="valorEncargos"
              column
              style={{ ...style9, fontSize: fontSize }}
            ></Form.Label>
          </Form.Group>
          <Form.Group
            id="perDepreciacao"
            as={Row}
            style={{
              flexWrap: "nowrap",
              marginLeft: "0px",
              marginRight: "0px",
              marginBottom: "5px",

              width: "30%",
            }}
          >
            <Form.Label
              id="label_mccr_percD"
              column
              style={{ flexGrow: "1", fontSize: fontSize }}
            >
              Depreciação Física, Funcional e Económica (CC+E+L)*D
            </Form.Label>
            <input
              id="mccr_percD"
              style={{ width: "30%" }}
              className="form-control create-text-input-suffix-fix"
              type="text"
              size={6}
              name={"mccr_percD"}
              maxLength={6}
              value={mccr_percD}
              onChange={(e) => setFormData13(e.target.value)}
              onBlur={() => {
                updateTotais(64, 72);
              }}
            />
            <InputGroup.Append>
              <InputGroup.Text
                className={"create-text-input-suffix"}
                style={{ height: "44px" }}
              >
                %
              </InputGroup.Text>
            </InputGroup.Append>
          </Form.Group>
          <Form.Group as={Row} style={style6}>
            <Form.Label
              id="label_mccr_valorD"
              column
              style={{ flexGrow: "1", fontSize: fontSize }}
            >
              D =
            </Form.Label>
            <Form.Label
              id="depreciacao"
              column
              style={{ ...style9, fontSize: fontSize }}
            ></Form.Label>
          </Form.Group>
        </Form.Group>

        <Form.Group as={Row} style={style4}>
          <Form.Group as={Row} style={style5}>
            <Form.Label
              id='label_""'
              column
              style={{ flexGrow: "1", fontSize: fontSize }}
            >
              Custos de construção + Encargos indiretos
            </Form.Label>
          </Form.Group>
          <Form.Group as={Row} style={style6}>
            <Form.Label
              id="label_mccr_valorCCE"
              column
              style={{ flexGrow: "1", fontSize: fontSize }}
            >
              CC + E =
            </Form.Label>
            <Form.Label
              id="ccEncargos"
              column
              style={{ ...style9, fontSize: fontSize }}
            ></Form.Label>
          </Form.Group>
          <Form.Group id="perConstrucao" as={Row} style={style5}>
            <Form.Label
              id="label_mccr_percConstReal"
              column
              style={{ flexGrow: "1", fontSize: fontSize }}
            >
              % de construção realizada
            </Form.Label>
            <input
              id="mccr_percConstReal"
              style={{ width: "30%" }}
              className="form-control create-text-input-suffix-fix"
              type="text"
              size={6}
              name={"mccr_percConstReal"}
              maxLength={13}
              value={mccr_percConstReal}
              onChange={(e) => setFormData14(e.target.value)}
              onBlur={() => {
                updateTotais(64, 72);
              }}
            />
            <InputGroup.Append>
              <InputGroup.Text
                className={"create-text-input-suffix"}
                style={{ height: "44px" }}
              >
                %
              </InputGroup.Text>
            </InputGroup.Append>
          </Form.Group>
        </Form.Group>

        <Form.Group as={Row} style={style4}>
          <Form.Group as={Row} style={style5}>
            <Form.Label
              id='label_""'
              column
              style={{ flexGrow: "1", fontSize: fontSize }}
            >
              Custo Total (CC+E+T)
            </Form.Label>
          </Form.Group>
          <Form.Group as={Row} style={style6}>
            <Form.Label
              id="label_mccr_valorCt"
              column
              style={{ flexGrow: "1", fontSize: fontSize }}
            >
              Ct =
            </Form.Label>
            <Form.Label
              id="custoTotal"
              column
              style={{ ...style9, fontSize: fontSize }}
            ></Form.Label>
          </Form.Group>
          <Form.Group as={Row} style={style7}>
            <Form.Label
              id="label_mccr_valorAtual"
              column
              style={{ flexGrow: "1", fontSize: fontSize }}
            >
              Valor Actual de acordo com % de construção realizada
              (T+%construção*(CC+E+L)-D
            </Form.Label>
            <Form.Label
              id="valorAtual"
              column
              style={{ ...style9, fontSize: fontSize }}
            ></Form.Label>
          </Form.Group>
        </Form.Group>

        <Form.Group as={Row} style={style4}>
          <Form.Group id="margemLucro" as={Row} style={style5}>
            <Form.Label
              id="label_mccr_percL"
              column
              style={{ flexGrow: "1", fontSize: fontSize }}
            >
              Margem de Lucro do Promotor (% de Ct)
            </Form.Label>
            <input
              id="mccr_percL"
              style={{ width: "30%" }}
              className="form-control create-text-input-suffix-fix"
              type="text"
              size={6}
              name={"mccr_percL"}
              value={mccr_percL}
              onChange={(e) => setFormData15(e.target.value)}
              onBlur={() => {
                updateTotais(64, 72);
              }}
              maxLength={6}
            />
            <InputGroup.Append>
              <InputGroup.Text
                className={"create-text-input-suffix"}
                style={{ height: "44px" }}
              >
                %
              </InputGroup.Text>
            </InputGroup.Append>
          </Form.Group>
          <Form.Group as={Row} style={style6}>
            <Form.Label
              id="label_mccr_valorL"
              column
              style={{ flexGrow: "1", fontSize: fontSize }}
            >
              L =
            </Form.Label>
            <Form.Label
              id="lucro"
              column
              style={{ ...style9, fontSize: fontSize }}
            ></Form.Label>
          </Form.Group>
          <Form.Group as={Row} style={style7}>
            <Form.Label
              id="label_mccr_valorSeguro"
              column
              style={{ flexGrow: "1", fontSize: fontSize }}
            >
              Valor para efeitos de Seguro (CC+E)
            </Form.Label>
            <Form.Label
              id="valorSeguro"
              column
              style={{ ...style9, fontSize: fontSize }}
            ></Form.Label>
          </Form.Group>
        </Form.Group>

        <Form.Group as={Row} style={style4}>
          <Form.Group
            as={Row}
            style={{
              flexWrap: "nowrap",
              margin: "0px",
              width: "50%",
            }}
          >
            <Form.Label
              id="label_mccr_valorNovo"
              column
              style={{ flexGrow: "1", fontSize: fontSize }}
            >
              Valor Novo (Ct + L)
            </Form.Label>
            <Form.Label
              id="valorNovo"
              column
              style={{ ...style9, fontSize: fontSize }}
            ></Form.Label>
          </Form.Group>
        </Form.Group>

        <Form.Group as={Row} style={style4}>
          <Form.Group
            as={Row}
            style={{
              flexWrap: "nowrap",
              paddingRight: "0px",
              paddingLeft: "0px",
              margin: "0px",
              width: "100%",
            }}
          >
            <Form.Label
              id="label_mccr_valorMetodoCusto"
              column
              style={{ flexGrow: "1", fontSize: fontSize }}
            >
              V - Valor Comercial
            </Form.Label>
            <Form.Label
              id="valorComercial"
              column
              style={{ ...style9, fontSize: fontSize }}
            ></Form.Label>
            <hr />
          </Form.Group>
        </Form.Group>

        <Form.Group as={Row} style={style8}>
          <Col key={`columndivision_1}`} style={{ padding: "0px" }}>
            {areaBruta && (
              <CreateTextInput
                id="areaBruta"
                field={areaBruta}
                key={areaBruta.variable}
                onBlur={() => updateTotais(64, 72)}
              />
            )}

            <Form.Group as={Row} style={style3}>
              <Form.Label
                id="label_lvRep"
                column
                style={{ maxWidth: "200px", fontSize: fontSize }}
              >
                IV adoptado
              </Form.Label>
              <Form.Label
                id="ivAdoptado"
                column
                style={{ ...style11, fontSize: fontSize }}
              ></Form.Label>
            </Form.Group>
          </Col>
        </Form.Group>

        <Form.Group as={Row} style={style8}>
          <Col key={`columndivision_1}`}>
            <Alert variant="info">
              Comparativo de Valores (Método Comparativo / Método Custos de
              construção Reposição)
            </Alert>
          </Col>
        </Form.Group>

        <div
          style={{
            display: "flex",
            flexWrap: "nowrap",
            width: "70%",
          }}
        >
          <Col key={`columndivision_1}`} style={{ padding: "0px" }}>
            <Form.Group as={Row} style={style3}>
              <Form.Label column style={{ flexGrow: "1", fontSize: fontSize }}>
                Valor Met Comp
              </Form.Label>
              <Form.Label
                id="valorMetComp"
                column
                style={{
                  flexGrow: "1",
                  fontWeight: "bold",
                  fontSize: fontSize,
                }}
              >
                {valorMetComp &&
                  formatter.format(
                    Number(parseCurrency(valorMetComp)).toFixed(2)
                  )}
              </Form.Label>
            </Form.Group>
          </Col>

          <Form.Label
            id="comparativo"
            column
            style={{ flexGrow: "0.2", fontSize: fontSize }}
          ></Form.Label>

          <Col key={`columndivision_3}`} style={{ padding: "0px" }}>
            <Form.Group as={Row} style={style3}>
              <Form.Label column style={{ flexGrow: "1", fontSize: fontSize }}>
                Valor Met Custos
              </Form.Label>
              <Form.Label
                id="valorMetCustos"
                column
                style={{
                  flexGrow: "1",
                  fontWeight: "bold",
                  fontSize: fontSize,
                }}
              ></Form.Label>
            </Form.Group>
          </Col>
        </div>

        <Form.Group as={Row} style={style8}>
          <Col key={`columndivision_1}`} style={{ padding: "0px" }}>
            {orcClienteRep && (
              <CreateTextInput
                field={orcClienteRep}
                key={orcClienteRep.variable}
              />
            )}
            {orcAceiteRep && (
              <CreateTextInput
                field={orcAceiteRep}
                key={orcAceiteRep.variable}
              />
            )}

            {empreiteiroRep && (
              <CreateTextInput field={empreiteiroRep} key={"empreiteiroRep"} />
            )}

            {licCamarariaRep && (
              <CreateSearchableDropdown
                field={licCamarariaRep}
                key={"licCamarariaRep"}
              />
            )}

            {numLicRep && (
              <CreateTextInput field={numLicRep} key={"numLicRep"} />
            )}

            {dtValidadeLicRep && (
              <CreateDateInput
                field={dtValidadeLicRep}
                key={"dtValidadeLicRep"}
              />
            )}

            {mccr_observacoes && (
              <CreateTextArea
                field={mccr_observacoes}
                key={"mccr_observacoes"}
              />
            )}
          </Col>
        </Form.Group>
      </>
    );
  };

  return (
    <Row
      key={`blockdivision_comparativo`}
      style={{ width: "100%", flexWrap: "nowrap", margin: "0px" }}
    >
      <Col key={`columndivision_comparativo}`} style={{ flexGrow: "1" }}>
        {renderColumnContent()}
      </Col>
    </Row>
  );
};
export default CreateCalculosCusto;
